import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { insuranceCompanyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const InsuranceCompany = ({ t, validateInsuranceCompany, insuranceCompanyError, insuranceCompanyValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { insuranceCompany } = useSelector((state) => state.app)

  const handleInsuranceCompany = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(insuranceCompanyAction(name))
      //validateInsuranceCompany(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurInsuranceCompany = (e) => {
    try {
      let name = e.currentTarget.value.trim()
      SetIsFocussed(false)
      dispatch(insuranceCompanyAction(name))
      validateInsuranceCompany(insuranceCompany)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        insuranceCompanyValid === true
          ? insuranceCompany !== '' && 'form-group has-success'
          : insuranceCompanyValid === false && 'form-group ns-form-group-message-error',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="InsuranceCompany">
        <b>{t('insurance_information.insurance_company')}</b>
      </label>

      {insuranceCompanyValid === false && (
        <div className="ns-form-error-container has-error error-msg-align">
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(insuranceCompanyError)}</div>
        </div>
      )}
      <input
        autoFocus
        style={{ width: '350px' }}
        type="text"
        id="InsuranceCompany"
        className="form-control"
        value={insuranceCompany.toUpperCase()}
        onChange={handleInsuranceCompany}
        //onBlur={onBlurInsuranceCompany}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="50"
      />
      {insuranceCompanyValid === true && insuranceCompany !== '' && (
        <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
      )}
    </div>
  )
}

export default withTranslation('common')(InsuranceCompany)
